import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LegendToggler } from "../../../../modules/LayerList/styled";
import { AdditionalParametersToggler } from "../styled";
import { useToggle } from "../../../../hooks/useToggle";

export const useAdditionalParameters = () => {
  const { t } = useTranslation("dialogs");
  const [showMore, toggleMore] = useToggle();

  const toggleButton = useMemo(() => {
    return (
      <AdditionalParametersToggler>
        <LegendToggler toggled={showMore} onClick={toggleMore}>
          {t("deleteResources.additionalParameters")}
        </LegendToggler>
      </AdditionalParametersToggler>
    );
  }, [showMore, t, toggleMore]);

  return {
    showMore,
    toggleButton,
  };
};
